import { env } from "../config/env";
import { createClient } from "./http";

const api = createClient(env.CATALOG_BASE_URL);

export const importService = {
  async uploadExcel(file) {
    if (!file) throw new Error("File is required");

    const formData = new FormData();
    formData.append("file", file);

    return api.post("/api/admin/import/excel", formData);
  },

  async previewImport(jobId) {
    if (!jobId) throw new Error("jobId is required");
    return api.get(`/api/admin/import/jobs/${jobId}/preview`);
  },

  async commitImport(jobId, payload = {}) {
    if (!jobId) throw new Error("jobId is required");
    return api.post(`/api/admin/import/jobs/${jobId}/commit`, payload);
  },
};